import { makeStyles } from '@material-ui/styles';

export default makeStyles(
    {
        barra: {
            backgroundColor: 'white',
            zIndex: 5,
            height: '70px',
            boxShadow: '0px 15px 19px rgba(47, 65, 81, 0.04)',
        },

        container: {
            display: 'flex',
            height: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
        },

        containerLogo: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
        },

        containerTitulo: {
            justifyContent: 'center',
            alignItems: 'center',
        },

        containerPrestador: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },

        logo: {
            height: '22px',
        },

        titulo: {
            fontSize: '16px',
            lineHeight: '18px',
            fontWeight: '400',
            textAlign: 'center',
            letterSpacing: '-0.04em',
            color: '#011328',
        },

        containerIcono: {
            background: '#E7EFFA',
            height: 30,
            width: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 15,
        },

        icono: {
            height: 12,
        },

        codPrestador: {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: '500',
            textAlign: 'center',
            letterSpacing: '-0.04em',
            color: '#02599E',
            marginLeft: 12,
        },

        version: {
            fontSize: '12px',
            fontWeight: '400',
            marginLeft: '12px',
            display: 'flex'
        },

        containerLogoVersion: {
            display: 'flex',
            width: 'max-content',
            alignItems: 'flex-end',
            margin: 0,
            padding: 0
        }
    },
    { index: 1 }
);
